var _rect, _rect2, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1456_169112)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext5_1",
    x: 0.273438,
    width: 40,
    height: 40,
    rx: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "ext2_2",
    x: -6.39258,
    y: 54.1667,
    width: 34.1667,
    height: 62.5,
    transform: "rotate(-90 -6.39258 54.1667)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "ext2_1",
    x: 40.5977,
    y: -8.33331,
    width: 16.6667,
    height: 63.0291,
    transform: "rotate(29.6266 40.5977 -8.33331)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_169112"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.273438,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault2);
export default __webpack_public_path__ + "static/media/Default2.83b7737d.svg";
export { ForwardRef as ReactComponent };